import { render } from "./IpAnomalyComponent.vue?vue&type=template&id=a9d01a4c"
import script from "./IpAnomalyComponent.vue?vue&type=script&lang=js"
export * from "./IpAnomalyComponent.vue?vue&type=script&lang=js"

import exportComponent from "C:\\agilS\\agil.webgisprod\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__